import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "../public/static/iconfont/iconfont.css";
import "../public/static/appStoreIconFont/iconfont.js";
import store from "./store";
import { initElement } from "./components/elementPuls";
import "@/styles/style.less";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
const app = createApp(App);

initElement(app);

app.use(store).use(router).mount("#app");
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
